module.exports = __webpack_public_path__ + "img/contact-icon.7ec93bee.webp";